import React from 'react';
import { useTranslation, Trans } from "react-i18next";

function AppRelease() {
	const { t } = useTranslation();

	return (
		<div className="releasenotice">
			<div className="releasenotice__inner">
				<dl className="releasenotice__items">
					<input id="info1" type="checkbox" />
					<label htmlFor="info1">
						<dt className="releasenotice__item">
							<h2><Trans i18nKey="appReleaseInfo.title" components={{ l: <a className="qa-links__item" href={t("appReleaseInfo.titleLink")} target="_blank">link</a> }}/></h2>
							<p>{t("appReleaseInfo.guide")}</p>
						</dt>
					</label>
					<dd><p>{t("appReleaseInfo.text")}</p></dd>
				</dl>
			</div>
		</div>
	);
}

export default AppRelease;
